import axiosClient from 'utils/axiosClient';
import api from 'api';

const getModules = async (data: any) => {
	const response = await axiosClient.get(api.REPORTS.REPORTS_MODULE, {params: data});
	return response.data;
};

const getModuleGrades = async (id: number, data: any) => {
	const response = await axiosClient.get(`${api.REPORTS.REPORTS_MODULE}/${id}`, {params: data});
	return response.data;
};

const getModuleSubjectGrades = async (id: number, data: any) => {
	const response = await axiosClient.get(`${api.REPORTS.REPORTS_MODULE}/${id}/grades`, {params: data});
	return response.data;
};

const service = {
	getModules,
	getModuleSubjectGrades,
	getModuleGrades
};

export default service;
